/* HundeLabs redesign 2026-09 – behaviour for the hl- sections and product page upgrades. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = (window.theme && theme.money_format) || '{{amount_with_comma_separator}} €';
    var v = (cents / 100).toFixed(2);
    var comma = v.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d),)/g, '.');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma).replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
  }

  /* ---------- Reveal on scroll (content above the fold is never hidden) ---------- */
  function initReveal() {
    var els = $$('.hl-rv, .hl-io');
    if (reduce || designMode || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) el.classList.add('in');
      else io.observe(el);
    });
    root.classList.add('hl-js');
  }

  /* ---------- Count-up numbers ---------- */
  function initCount() {
    var els = $$('[data-hl-count]');
    if (!els.length) return;
    var run = function (el) {
      var to = parseFloat(el.getAttribute('data-hl-count')) || 0, suf = el.getAttribute('data-hl-suffix') || '';
      if (reduce) { el.textContent = to + suf; return; }
      var t0 = performance.now();
      (function step(t) {
        var k = Math.min(1, (t - t0) / 1300), e = 1 - Math.pow(1 - k, 3);
        el.textContent = Math.round(to * e) + suf;
        if (k < 1) requestAnimationFrame(step);
      })(t0);
    };
    if (!('IntersectionObserver' in window) || designMode) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); run(e.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Test finder ---------- */
  function initFinder() {
    $$('[data-hl-finder]').forEach(function (f) {
      var tabs = $$('.hl-fchip', f);
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) {
            var on = x === t;
            x.setAttribute('aria-selected', on);
            var p = document.getElementById(x.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
          });
        });
      });
    });
  }

  /* ---------- Review rows: arrows ---------- */
  function initScroller() {
    $$('[data-hl-scroller]').forEach(function (w) {
      var row = $('[data-hl-row]', w);
      if (!row) return;
      $$('[data-dir]', w).forEach(function (b) {
        b.addEventListener('click', function () { row.scrollBy({ left: +b.getAttribute('data-dir') * row.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' }); });
      });
    });
  }

  /* ---------- Test scope search ---------- */
  function initTestList() {
    $$('[data-hl-tx]').forEach(function (tx) {
      var data;
      try { data = JSON.parse($('[data-hl-tx-data]', tx).textContent); } catch (e) { return; }
      var cats = Object.keys(data);
      if (!cats.length) return;
      var catWrap = $('.hl-tx__cats', tx), items = $('.hl-tx__items', tx), input = $('input', tx), ans = $('.hl-tx__answer', tx);
      var cur = cats[0];
      var esc = function (s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      var norm = function (t) { return t.toLowerCase().replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 's'); };
      catWrap.innerHTML = cats.map(function (c) { return '<button type="button" class="hl-tx__cat" data-c="' + esc(c) + '" aria-pressed="' + (c === cur) + '">' + esc(c) + ' <em>' + data[c].length + '</em></button>'; }).join('');
      function show() {
        var q = input.value.trim();
        if (q.length >= 2) {
          var nq = norm(q), hits = [];
          cats.forEach(function (c) { data[c].forEach(function (it) { var k = norm(it).indexOf(nq); if (k > -1) hits.push([c, it, k]); }); });
          $$('.hl-tx__cat', tx).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          items.innerHTML = hits.map(function (h, i) {
            return '<span class="hl-tx__item hit" style="animation-delay:' + Math.min(i, 12) * 25 + 'ms">' + esc(h[1].slice(0, h[2])) + '<mark>' + esc(h[1].slice(h[2], h[2] + nq.length)) + '</mark>' + esc(h[1].slice(h[2] + nq.length)) + ' <small>· ' + esc(h[0]) + '</small></span>';
          }).join('');
          ans.className = 'hl-tx__answer ' + (hits.length ? 'yes' : 'no');
          ans.textContent = hits.length ? '✓ Ja – „' + q + '“ ist im Test enthalten (' + hits.length + ' Treffer).' : '„' + q + '“ ist nicht in der Liste – fragen Sie uns gern.';
          items.scrollTop = 0; fade();
          return;
        }
        ans.textContent = ''; ans.className = 'hl-tx__answer';
        $$('.hl-tx__cat', tx).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c') === cur); });
        items.innerHTML = data[cur].map(function (it, i) { return '<span class="hl-tx__item" style="animation-delay:' + Math.min(i, 16) * 18 + 'ms">' + esc(it) + '</span>'; }).join('');
        items.scrollTop = 0; fade();
      }
      var fade = function () { items.classList.toggle('hl-fade', items.scrollHeight - items.scrollTop - items.clientHeight > 6); };
      items.addEventListener('scroll', fade, { passive: true });
      catWrap.addEventListener('click', function (e) { var b = e.target.closest('.hl-tx__cat'); if (!b) return; cur = b.getAttribute('data-c'); input.value = ''; show(); });
      input.addEventListener('input', show);
      show();
    });
  }

  /* ---------- FAQ hub: search + topic filter (umlaut-tolerant), #faq-<topic> deep links ---------- */
  function initFaq() {
    $$('[data-hl-faq]').forEach(function (root) {
      var input = $('.hl-faq__search input', root), status = $('[data-hl-faq-status]', root), empty = $('[data-hl-faq-empty]', root);
      var chips = $$('.hl-faq__chip', root), groups = $$('.hl-faqg', root), topic = '';
      var norm = function (t) { return (t || '').toLowerCase().replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss'); };
      var items = $$('.hl-faqq', root).map(function (d) { return { el: d, g: d.closest('.hl-faqg'), q: norm($('summary', d).textContent), a: norm($('.hl-faqq__a', d).textContent) }; });
      var label = function (n) { return n + (n === 1 ? ' Antwort' : ' Antworten'); };
      function apply() {
        var raw = input.value.trim(), q = norm(raw), searching = q.length >= 2, shown = 0;
        items.forEach(function (it) {
          var ok = (!topic || it.g.getAttribute('data-topic') === topic) && (!searching || it.q.indexOf(q) > -1 || it.a.indexOf(q) > -1);
          it.el.hidden = !ok;
          if (ok) shown++;
        });
        groups.forEach(function (g) { g.hidden = !$$('.hl-faqq', g).some(function (d) { return !d.hidden; }); });
        empty.hidden = shown > 0;
        status.textContent = searching ? label(shown) + ' zu „' + raw + '“' : label(shown);
      }
      input.addEventListener('input', apply);
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          topic = c.getAttribute('data-topic');
          chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c); });
          apply();
        });
      });
      var h = decodeURIComponent(location.hash.replace(/^#faq-/, ''));
      var pre = h && chips.filter(function (x) { return x.getAttribute('data-topic') === h; })[0];
      if (pre) pre.click(); else apply();
    });
  }

  /* ---------- Test overview: complaint filter (instant, #thema-… in the URL) + native sort ---------- */
  function initColl() {
    $$('[data-hl-coll]').forEach(function (root) {
      var chips = $$('.hl-coll__chip', root), cards = $$('.hl-ccard', root);
      var status = $('[data-hl-coll-status]', root), empty = $('[data-hl-coll-empty]', root), sort = $('[data-hl-coll-sort]', root);
      function apply(topic) {
        var n = 0;
        cards.forEach(function (c) {
          var ok = !topic || (' ' + c.getAttribute('data-topics') + ' ').indexOf(' ' + topic + ' ') > -1;
          c.hidden = !ok; if (ok) n++;
        });
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-topic') === topic); });
        status.textContent = n + (n === 1 ? ' Test' : ' Tests') + (topic ? ' passend zu „' + $('.hl-coll__chip[data-topic="' + topic + '"]', root).textContent.trim() + '“' : '');
        empty.hidden = n > 0;
      }
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          var t = c.getAttribute('data-topic');
          apply(t);
          if (history.replaceState) history.replaceState(null, '', location.pathname + location.search + (t ? '#thema-' + t : ''));
        });
      });
      if (sort) sort.addEventListener('change', function () {
        var u = new URL(location.href);
        if (sort.value === 'manual') u.searchParams.delete('sort_by'); else u.searchParams.set('sort_by', sort.value);
        location.href = u.toString();
      });
      var h = decodeURIComponent(location.hash.replace(/^#thema-/, ''));
      apply(h && $('.hl-coll__chip[data-topic="' + h + '"]', root) ? h : '');
    });
  }

  /* ---------- Product page: live sum in button, add-on, sticky bar, bundle ---------- */
  function initProduct() {
    var detail = $('.product-detail');
    if (!detail) return;
    var form = $('.product-purchase-form', detail);
    var btn = form ? $('.quantity-submit-row__submit button[type="submit"]', form) : null;
    var select = form ? $('select[name="id"]', form) : null;
    var json = $('script[id^="ProductJson-"]', detail);
    var product = null;
    try { product = json ? JSON.parse(json.textContent) : null; } catch (e) { product = null; }
    var addon = $('.hl-addon', detail);
    var addonBox = addon ? $('input[type="checkbox"]', addon) : null;
    var addonPrice = addon ? parseInt(addon.getAttribute('data-hl-addon-price'), 10) || 0 : 0;
    /* Google automated discounts (visitors from Google Shopping ads) rewrite the shown price –
       then our own price copies would be stale, so they are left out while it is active. */
    var gad = document.getElementById('google-automated-discounts-price');
    var gadOn = function () { return !!(gad && gad.textContent.trim()); };

    function variant() {
      if (!product || !select) return null;
      var id = parseInt(select.value, 10);
      for (var i = 0; i < product.variants.length; i++) if (product.variants[i].id === id) return product.variants[i];
      return product.variants[0];
    }
    function update() {
      var v = variant();
      if (!v) return;
      var extra = addonBox && addonBox.checked ? addonPrice : 0;
      if (btn) { if (gadOn()) btn.removeAttribute('data-hl-sum'); else btn.setAttribute('data-hl-sum', money(v.price + extra)); }
      $$('[data-hl-tier-price], [data-hl-satc-price], [data-hl-bundle-main]').forEach(function (el) { el.textContent = money(v.price); el.hidden = gadOn(); });
      var bundle = $('[data-hl-bundle]');
      if (bundle) {
        var sum = $('[data-hl-bundle-sum]', bundle);
        if (sum) sum.textContent = money(v.price + (parseInt(bundle.getAttribute('data-addon-price'), 10) || 0));
      }
    }
    if (select) select.addEventListener('change', function () { setTimeout(update, 0); });
    if (window.jQuery) window.jQuery(window).on('cc-variant-updated', function () { setTimeout(update, 0); });
    detail.addEventListener('change', function (e) { if (e.target.classList && e.target.classList.contains('js-option')) setTimeout(update, 30); });
    if (addonBox) addonBox.addEventListener('change', function () { addon.classList.toggle('is-on', addonBox.checked); update(); });
    var addonToggle = addon ? $('.hl-addon__toggle', addon) : null;
    if (addonToggle) addonToggle.addEventListener('click', function () { addonToggle.setAttribute('aria-expanded', addon.classList.toggle('is-expanded')); });
    if (gad && 'MutationObserver' in window) new MutationObserver(function () { update(); }).observe(gad, { childList: true, subtree: true, characterData: true });
    /* ?report=1 (link from the Futter-Check) pre-selects the Nahrungsmittel-Report add-on */
    if (addonBox && !addonBox.checked && /[?&]report=1(&|$)/.test(location.search)) addonBox.click();
    update();

    /* Sticky bar */
    var satc = $('[data-hl-satc]');
    if (satc && btn) {
      var ticking = false;
      var check = function () {
        ticking = false;
        var on = btn.getBoundingClientRect().bottom < 0 && window.innerWidth < 768;
        satc.classList.toggle('is-on', on);
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      check();
      $('[data-hl-satc-btn]', satc).addEventListener('click', function () {
        btn.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        setTimeout(function () { btn.click(); }, reduce ? 0 : 450);
      });
    }

    /* Bundle: test + add-on in one click.
       Goes through the normal buy button so the required dog-name field (Infinite Options)
       is validated and saved on the line item; the add-on checkbox adds the report as usual. */
    var bundleBtn = $('[data-hl-bundle-add]');
    if (bundleBtn) {
      bundleBtn.addEventListener('click', function () {
        var bundle = bundleBtn.closest('[data-hl-bundle]');
        var addId = bundle.getAttribute('data-addon-variant');
        if (btn && addonBox && addonBox.getAttribute('data-upsell-variant') === addId) {
          if (!addonBox.checked) addonBox.click();
          btn.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          setTimeout(function () { btn.click(); }, reduce ? 0 : 450);
          return;
        }
        /* Fallback (no matching add-on checkbox): add both directly, with the form's line-item properties */
        var v = variant();
        if (!v || !addId || !form) return;
        var props = {}, missing = null;
        $$('[name^="properties["]', document).forEach(function (el) {
          if (el.form !== form && !form.contains(el)) return;
          if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
          var k = el.name.slice(11, -1);
          if ((el.required || el.hasAttribute('data-hl-required')) && !el.value.trim() && !missing) missing = el;
          if (el.value.trim()) props[k] = el.value.trim();
        });
        if (missing) { missing.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); missing.focus({ preventScroll: true }); return; }
        bundleBtn.classList.add('is-busy');
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }, { id: +addId, quantity: 1 }] }) })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function () {
            bundleBtn.classList.remove('is-busy'); bundleBtn.classList.add('is-done');
            var label = bundleBtn.textContent; bundleBtn.textContent = '✓ Beides im Warenkorb';
            document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
            setTimeout(function () { bundleBtn.classList.remove('is-done'); bundleBtn.textContent = label; }, 2600);
          })
          .catch(function () { bundleBtn.classList.remove('is-busy'); });
      });
    }
  }

  function init() {
    initReveal();
    initCount();
    initFinder();
    initScroller();
    initTestList();
    initFaq();
    initColl();
    initProduct();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Dog name (own field, replaces the Infinite Options app): checked before the theme's AJAX add-to-cart.
     Capture phase on document runs before the theme's submit handler on the form, so an empty name never
     reaches the cart; the message appears inline instead of a browser alert. */
  function hlDogErr(el, on) {
    var wrap = el.closest('[data-hl-dogname]');
    if (!wrap) return;
    wrap.classList.toggle('is-invalid', on);
    var msg = wrap.querySelector('.hl-dogname__err');
    if (msg) msg.hidden = !on;
    el.setAttribute('aria-invalid', on ? 'true' : 'false');
  }
  function hlDogBlocked(e, form) {
    var bad = $$('[data-hl-required]').filter(function (el) { return el.form === form && !el.value.trim(); });
    if (!bad.length) return false;
    e.preventDefault();
    e.stopImmediatePropagation();
    bad.forEach(function (el) { hlDogErr(el, true); });
    bad[0].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    setTimeout(function () { bad[0].focus({ preventScroll: true }); }, reduce ? 0 : 350);
    return true;
  }
  /* click (capture) runs before the Infinite Options click check and the theme; submit covers the Enter key */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[type="submit"], input[type="submit"]');
    if (btn && btn.form && btn.form.matches('form[action*="/cart/add"]')) hlDogBlocked(e, btn.form);
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches && form.matches('form[action*="/cart/add"]')) hlDogBlocked(e, form);
  }, true);
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el.matches || !el.matches('[data-hl-dogname] input')) return;
    if (el.value.trim()) hlDogErr(el, false);
    /* While the Infinite Options app is still installed (script tag on every theme), its own hidden field
       gets the same value so its check passes; nothing happens once the app is uninstalled. */
    $$('#infiniteoptions-container input').forEach(function (x) {
      if (x.name !== el.name) return;
      x.value = el.value;
      x.dispatchEvent(new Event('input', { bubbles: true }));
      x.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* Test-Finder menu link: on the homepage scroll in place and close the mobile drawer */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.hl-nav-finder a');
    if (!a) return;
    var url = new URL(a.href, location.href), target = url.hash && document.querySelector(url.hash);
    if (url.pathname !== location.pathname || !target) return;
    e.preventDefault();
    var body = document.body;
    if (body.classList.contains('reveal-mobile-nav')) {
      body.classList.remove('reveal-mobile-nav');
      setTimeout(function () { body.classList.remove('enable-mobile-nav-transition'); }, 750);
    }
    setTimeout(function () {
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', url.hash);
    }, body.classList.contains('enable-mobile-nav-transition') ? 350 : 0);
  });

  /* Theme editor: re-init when sections are re-rendered */
  document.addEventListener('shopify:section:load', function () { initFinder(); initScroller(); initTestList(); $$('.hl-rv, .hl-io').forEach(function (el) { el.classList.add('in'); }); });
})();
